import { render, staticRenderFns } from "./ValueSvg.vue?vue&type=template&id=8e7f1d82&"
import script from "./ValueSvg.vue?vue&type=script&lang=js&"
export * from "./ValueSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports